module.exports = __webpack_public_path__ + "img/about-page.9d80ddc7.jpg";